module.exports = __webpack_public_path__ + "img/reduce-congestion-depth.a0fb0f3a.webp";